import React from 'react'

import { type StarChartsActionContainerProps } from '../../types/types'
import StarChartsActionPresentation from '../../presentation/starChart.action.presentation/StarChartsActionPresentation'

const StarChartsActionContainer: React.FC<StarChartsActionContainerProps> = ({
  openStarChartsAddHandler,
  term,
  setTerm
}) => {
  return (
    <StarChartsActionPresentation
      openStarChartsAddHandler={openStarChartsAddHandler}
      term={term}
      setTerm={setTerm}
    />
  )
}

export default StarChartsActionContainer
